import React from 'react';
import * as Yup from 'yup';

import routes from 'app/routes';

import { Formik, Form as FormikForm, FieldArray } from 'formik';

import { Row, Col, Button } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import {
  TextField,
  TextAreaField,
  SubmitButton,
} from 'ui/FormElement';

import deleteIcon from 'images/icons/invite/delete.svg';

export default function Index({ enterpriseId, onSave, data }) {
  const FormSchema = Yup.object().shape({
    title: Yup.string().required('required'),
    items: Yup.array().of(
      Yup.object().shape({
        title: Yup.string().required('required'),
        answer: Yup.string().required('required'),
      }),
    ),
  });

  const formData = {
    title: data ? data.title : '',
    description: data ? data.description : '',
    items: data ? data.items.map((item) => ({
      title: item.attributes.title,
      answer: item.attributes.answer,
      id: item.id,
    })) : [],
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(true);
    onSave(values);
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      {({ values, isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <div className="mt20">
            <TextField
              name="title"
              label={(
                <>
                  <span>Name</span>
                  <abbr title="required">*</abbr>
                </>
            )}
            />
            <TextAreaField
              name="description"
              label={(
                <span>Description</span>
            )}
            />

            <FieldArray name="items">
              {({ remove, push }) => (
                <div>
                  <h3>Items</h3>
                  {values.items.map(
                    (item, index) => (
                      <Row className="mt20">
                        <Col md={1}>{index + 1}</Col>
                        <Col md={9}>
                          <TextField
                            name={`items.${index}.id`}
                            type="hidden"
                          />
                          <TextField
                            name={`items.${index}.title`}
                          />
                          <TextAreaField
                            name={`items.${index}.answer`}
                          />
                        </Col>
                        <Col md={2}>
                          <Button
                            bsStyle="link"
                            onClick={() => remove(index)}
                          >
                            <img src={deleteIcon} alt="delete" />
                          </Button>
                        </Col>
                      </Row>
                    ),
                  )}
                  <div className="text-right">
                    <Button
                      onClick={() => push({
                        id: null, title: '', answer: '',
                      })}
                      bsStyle="primary"
                    >
                      Add Item
                    </Button>
                  </div>
                </div>
              )}
            </FieldArray>

          </div>
          <div className="text-center mt20">
            <Link
              to={routes.admin.enterprise_briefs.index(enterpriseId)}
              className="btn btn-primary btn-outline mr5 ml5 width-120"
            >
              Cancel
            </Link>

            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Save'}
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                isSubmitting ? 'not-possible-click' : ''
              }`}
            />
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}
